export interface VehiclePopupProps {
  readonly lineName: string
  readonly lineType: string
  readonly color: string
  readonly headsign: string
  readonly directionId: string
  readonly vehicleId: string
  readonly nextStopName?: string
}

function getLineTypeLabel(type: string): string {
  return type === 'tram' ? 'Tramway' : 'Bus'
}

function getLineTypeIcon(type: string): string {
  return type === 'tram'
    ? '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="3" width="16" height="16" rx="2"/><path d="M4 11h16"/><path d="M12 3v8"/><path d="M8 19l-2 3"/><path d="M16 19l2 3"/><path d="M9 23h6"/></svg>'
    : '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M8 6v6"/><path d="M15 6v6"/><path d="M2 12h19.6"/><path d="M18 18h3s.5-1.7.8-2.8c.1-.4.2-.8.2-1.2 0-.4-.1-.8-.2-1.2l-1.4-5C20.1 6.8 19.1 6 18 6H4a2 2 0 0 0-2 2v10h3"/><circle cx="7" cy="18" r="2"/><path d="M9 18h5"/><circle cx="16" cy="18" r="2"/></svg>'
}

function formatHeadsign(lineName: string, headsign: string, directionId: string): string {
  if (lineName === 'T4') {
    const suffix = directionId === '0' ? 'A' : 'B'
    return `${headsign} ${suffix}`
  }
  return headsign
}

export function createVehiclePopupContent(props: VehiclePopupProps): string {
  const typeLabel = getLineTypeLabel(props.lineType)
  const typeIcon = getLineTypeIcon(props.lineType)
  const headsign = formatHeadsign(props.lineName, props.headsign, props.directionId)

  const nextStopHtml = props.nextStopName
    ? `<div class="vehicle-popup__next-stop">
    <span class="vehicle-popup__next-stop-label">Prochain arr\u00eat</span>
    <span class="vehicle-popup__next-stop-name">${props.nextStopName}</span>
  </div>`
    : ''

  return `<div class="vehicle-popup">
  <div class="vehicle-popup__header">
    <span class="vehicle-popup__icon">${typeIcon}</span>
    <span class="vehicle-popup__line" style="background-color: ${props.color}; color: #ffffff;">
      ${props.lineName}
    </span>
    <span class="vehicle-popup__type">${typeLabel}</span>
  </div>
  <div class="vehicle-popup__direction">
    ${headsign}
  </div>
  ${nextStopHtml}
  <div class="vehicle-popup__id">
    ${props.vehicleId}
  </div>
</div>`
}
